<template>
  <div class="flex flex-col items-center justify-center py-8">
    <div class="lds-ripple">
      <div></div>
      <div></div>
    </div>
    <p v-if="message" class="text-gray-600 mt-4 text-center">{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: 'LoadingRipple',
  props: {
    message: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'medium' // small, medium, large
    }
  }
}
</script>

<style scoped>
.lds-ripple,
.lds-ripple div {
  box-sizing: border-box;
}

.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-ripple div {
  position: absolute;
  border: 4px solid var(--color-primary);
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
  border-color: var(--color-secondary);
}

/* Size variations */
.lds-ripple.small {
  width: 40px;
  height: 40px;
}

.lds-ripple.small div {
  border-width: 2px;
}

.lds-ripple.large {
  width: 120px;
  height: 120px;
}

.lds-ripple.large div {
  border-width: 6px;
}

@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 8px;
    height: 8px;
    opacity: 0;
  }
  4.9% {
    top: 36px;
    left: 36px;
    width: 8px;
    height: 8px;
    opacity: 0;
  }
  5% {
    top: 36px;
    left: 36px;
    width: 8px;
    height: 8px;
    opacity: 1;
  }
  100% {
    top: 0;
    left: 0;
    width: 80px;
    height: 80px;
    opacity: 0;
  }
}

/* Adjustments for different sizes */
@media (max-width: 768px) {
  .lds-ripple {
    width: 60px;
    height: 60px;
  }
  
  @keyframes lds-ripple {
    0% {
      top: 28px;
      left: 28px;
      width: 6px;
      height: 6px;
      opacity: 0;
    }
    4.9% {
      top: 28px;
      left: 28px;
      width: 6px;
      height: 6px;
      opacity: 0;
    }
    5% {
      top: 28px;
      left: 28px;
      width: 6px;
      height: 6px;
      opacity: 1;
    }
    100% {
      top: 0;
      left: 0;
      width: 60px;
      height: 60px;
      opacity: 0;
    }
  }
}
</style>